import { Component, Input, OnDestroy, OnInit, TemplateRef } from '@angular/core';
import icShoppingBasket from '@iconify/icons-ic/twotone-shopping-basket';
import { Router } from '@angular/router';
import { NavigationService } from '../../services/theme/navigation.service';
import { ConfigService } from 'src/@core/services/theme/config.service';
import { map } from 'rxjs/operators';
import { LayoutService } from 'src/@core/services/theme/layout.service';
import { permissions } from 'src/app/shared/helpers/roles-permissions';


@Component({
  selector: 'codemiro-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit, OnDestroy {


  @Input() customTemplate: TemplateRef<any>;
  permissions = permissions;
  icShoppingBasket = icShoppingBasket;
  navigationItems = this.navigationService.items;
  isVerticalLayout$ = this.configService.config$.pipe(map(config => config.layout === 'vertical'));
  isActive: boolean = false;




  constructor(
    private router: Router,
    private navigationService: NavigationService,
    private configService: ConfigService,
    private layoutService: LayoutService,
  ) { }

  ngOnInit() {
  }

  ngOnDestroy(): void {
  }

  openSidenav() {
    this.layoutService.openSidenav();
  }

  toggleActive() {
    this.isActive = !this.isActive;
    console.log(this.isActive);

  }

  // contact support 
  contactSupport() {
    window.open('https://wa.me/919818879566?text=Hello%20%I%20need%20help%20regarding%20my%20HOA%20account', '_blank');
  }
}
